import { db } from '@/plugins/firebase';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import * as storageServices from '@/services/storageServices';

export async function updateUserDoc(userId, payload) {
  const userDocRef = await db.collection('users').doc(userId);
  payload['updatedAt'] = moment().toDate();

  try {
    await userDocRef.set(payload, { merge: true });
    const userDocSnapShot = await userDocRef.get();
    return userDocSnapShot.data();
  } catch (err) {
    console.error(err);
    return;
  }
}

export async function createUserDoc(userId, payload) {
  const userDocRef = await db.collection('users').doc(userId);
  payload['createdAt'] = moment().toDate();
  payload['updatedAt'] = moment().toDate();

  try {
    await userDocRef.set(payload, { merge: true });
    const userDocSnapShot = await userDocRef.get();
    return userDocSnapShot.data();
  } catch (err) {
    console.error(err);
    throw err;
  }
}

export async function getUserDoc(userId) {
  const userDocQuerySnapShot = await db.collection('users').doc(userId).get();
  const userDoc = userDocQuerySnapShot.data();
  return userDoc;
}

export async function getLikedPerformers(userId) {
  let performers = [];

  const likedPerformersQuerySnapShot = await db
    .collection('users')
    .doc(userId)
    .collection('likedPerformers')
    .limit(20)
    .get();

  if (likedPerformersQuerySnapShot.empty) {
    return performers;
  } else {
    likedPerformersQuerySnapShot.forEach(doc => {
      const data = doc.data();
      performers.push({
        userId: doc.id,
        nickname: data.nickname,
        photoURL: data.photoURL
      });
    });
  }

  return performers;
}

export async function addLikedPerformer(userId, performerDoc) {
  const likedPerformerDocRef = await db
    .collection('users')
    .doc(userId)
    .collection('likedPerformers')
    .doc(performerDoc.performerId);

  await likedPerformerDocRef.set(performerDoc, { merge: true });
}

export async function removePerformersFromLiked(userId, performerIds) {
  if (performerIds.length == 0) return;

  const likedPerformersQuerySnapShot = await db
    .collection('users')
    .doc(userId)
    .collection('likedPerformers')
    .where('performerId', 'in', performerIds)
    .get();

  if (likedPerformersQuerySnapShot.empty) return;

  const batch = db.batch();
  likedPerformersQuerySnapShot.docs.forEach(doc => {
    batch.delete(doc.ref);
  });
  await batch.commit();
}

export async function performerIsLiked(userId, performerId) {
  const likedPerformersQuerySnapShot = await db
    .collection('users')
    .doc(userId)
    .collection('likedPerformers')
    .where('performerId', '==', performerId)
    .get();

  return likedPerformersQuerySnapShot.empty ? false : true;
}

/*
 * ユーザープロフィールの画像のアップロードを行って、
 * 成功したらそのファイルパスを返す。
 * 失敗したら空文字を返す。
 * もしすでにファイルがある場合は古いファイルを削除する。
 */
export async function uploadUserPhotoAndGetItsStoragePath(uid, photoFile) {
  if (!uid || !photoFile) {
    return '';
  }
  const storagePath = `users/${uid}/icon/${uuidv4()}`;
  const photoURL = await storageServices.uploadPhoto(storagePath, photoFile);
  return photoURL || '';
}
